import React from "react";
import styles from "./Partners.module.scss";
import { ReactComponent as IindyIcon } from "../../assets/iindy.svg";
import { ReactComponent as NearIcon } from "../../assets/near.svg";
import { ReactComponent as ParasIcon } from "../../assets/paras.svg";
import { ReactComponent as Wayne } from "../../assets/wayne.svg";
import { ReactComponent as Kofta } from "../../assets/kofta.svg";
import { ReactComponent as Unchain } from "../../assets/unchain.svg";

export default function Partners() {
  const partners = [
    { icon: IindyIcon, link: "https://iindy.co" },
    { icon: ParasIcon, link: "https://paras.id/" },
    { icon: NearIcon, link: "https://near.org/" },
    {
      icon: Wayne,
      link: "https://open.spotify.com/artist/4f44GWlEQdXaWl8gQ9sPBC?si=99gcEeMzQTmhGWgtFgSu8g&nd=1",
    },
    { icon: Kofta, link: "https://koftastudio.com/collections/couture" },
    { icon: Unchain, link: "https://unchain.fund/about" },
  ];
  return (
    <div className={styles.wrapper}>
      {partners.map((partner, index) => {
        return (
          <a
            href={partner.link}
            target={"_blank"}
            className={styles.partner}
            key={index}
          >
            <partner.icon />
          </a>
        );
      })}
    </div>
  );
}
